<template>
  <div>
    <el-dialog :title="title" :visible="countryModal" width="500px" top="3vh" :modal="true"
        :append-to-body="true" @close="setCountryModal(false)"
    >
      <h3 v-if="track.cid_territories_option === 'except'">User selected all countries except these ones:</h3>
      <h3 v-else-if="track.cid_territories_option === 'only'">User selected these countries only:</h3>

      <el-popover v-for="(cts, continent) in track.territories" :key="continent"
                  placement="bottom" title="Countries" width="200" trigger="click">
        <el-button slot="reference" class="mr10 mt10"
                   :type="track.cid_territories_option === 'except' ? 'primary' : 'success'"
        >{{ continent }}</el-button>
        <ul class="country-list">
          <li v-for="country in sorted(cts)" :key="country">{{ country }}</li>
        </ul>
      </el-popover>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  props: {
    title: { type: String, default: 'Countries' }
  },

  computed: {
    ...mapState('trackImport', ['countryModal', 'track', 'countries'])
  },

  methods: {
    ...mapMutations('trackImport', ['setCountryModal']),

    sorted(countries) {
      return countries.slice().sort((a, b) => a.localeCompare(b))
    }
  }
}
</script>

<style scoped lang="scss">
.country-list {
  max-height: 350px;
  overflow-y: scroll;
}
</style>